<app-layout>
    <mat-card class="mat-elevation-z0">
        <mat-card-title class="header">
            <h5 appLocalizationPopupDirective localizationCode="ImportEditor">{{ 'ImportEditor' | translate: {Default: "Import Editor"} }}</h5>

            <div>
                <mat-chip-list *ngIf="importObject">
                    <mat-chip 
                        [ngClass]="{
                            'red-chip': importObject.status?.id === 'VALIDATIONFAILED' || importObject.status?.id === 'FAILED' || importObject.status?.id === 'COMPLETEDWITHERRORS'  ,
                            'green-chip': importObject.status?.id === 'COMPLETED',
                            'orange-chip': importObject.status?.id === 'QUEUED' || importObject.status?.id === 'PENDING',
                            'blue-chip': importObject.status?.id === 'RUNNING'
                        }"
                    >{{ importObject.status?.name }}</mat-chip>
                </mat-chip-list>
                <button mat-stroked-button setColor="primaryColour" color="primary" appLocalizationPopupDirective localizationCode="BackToImports" appPreventDoubleClick (throttledClick)="backToImports()">
                    <mat-icon class="material-icons-outlined">arrow_back</mat-icon>
                    {{ 'BackToImports' | translate: {Default: "Back to Imports"} }}
                </button>
            </div>
        </mat-card-title>
        <mat-card-content>
            <div                 
                *ngIf="showStepper"
                class="buttons-container"
            >
                <app-bootstrap-alert 
                    *ngIf="!importId"
                    localizationCode="SaveToEnableColumnMappingPreview" 
                    type="warning"
                    [button]="{
                        localizationCode: 'Save'
                    }"
                    (buttonClick)="save()"
                >
                </app-bootstrap-alert>
                <app-bootstrap-alert 
                    *ngIf="showSaveButton"
                    localizationCode="SaveImportChanges" 
                    type="warning"
                    [button]="{
                        localizationCode: 'Save'
                    }"
                    (buttonClick)="save()"
                >
                </app-bootstrap-alert>
            </div>

            <mat-stepper 
                *ngIf="showStepper"
                #stepper 
                (selectionChange)="stepChange($event)" 
                [selectedIndex]="selectedStep"
            >
                <ng-template matStepperIcon="edit"><mat-icon style="margin-top: 3px; margin-left: 4px;" class="material-icons-outlined">create</mat-icon></ng-template>
        
                <mat-step>
                    <ng-template matStepLabel appLocalizationPopupDirective [localizationCode]="'Import-Step1'">
                        {{ 'Import-Step1' | translate: {Default: 'Import Configuration'} }}
                    </ng-template>
 
                    <ng-template matStepContent>
                        <div class="step-content step-1">
                            <div class="form-container">
                                <form [formGroup]="importForm" class="import-form">
                                    <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportName">
                                        <mat-label>
                                            {{ 'ImportName' | translate: {Default: "Name"} }}
                                        </mat-label>
        
                                        <input matInput type="text" formControlName="name">
                                    </mat-form-field>
        
                                    <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportDescription">
                                        <mat-label>
                                            {{ 'ImportDescription' | translate: {Default: "Description"} }}
                                        </mat-label>
        
                                        <textarea
                                            matInput
                                            cdkTextareaAutosize
                                            #autosize="cdkTextareaAutosize"
                                            cdkAutosizeMinRows="1"
                                            cdkAutosizeMaxRows="30"
                                            formControlName="description"></textarea>
                                    </mat-form-field>
        
                                    <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportCulture">
                                        <mat-label>
                                            {{ 'ImportCulture' | translate: {Default: "Culture"} }}
                                        </mat-label>
        
                                        <mat-select disableOptionCentering formControlName="culture">
                                            <mat-option></mat-option>
                                            <mat-option *ngFor="let option of cultures" [value]="option.id">{{ option.text }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
        
                                    <div class="file-input-container">
                                        <button mat-stroked-button setColor="primaryColour" color="primary" class="primary-button" appPreventDoubleClick (throttledClick)="fileInput.click()">
                                            {{ 'ChooseAFile' | translate: {Default: "Choose a file"} }}
                                        </button>
                                        <div class="current-file-details" *ngIf="currentFile">
                                            <div class="current-file-name">{{currentFile?.name}}</div>
                                            <div class="current-file-size">{{ currentFile?.size | filesize }}</div>
                                        </div>
                                        <input
                                            #fileInput
                                            type="file"
                                            id="fileInput"
                                            (change)="selectFile($event)"
                                            name="fileInput"
                                            formControlName="file"
                                        />
                                    </div>
        
                                    <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportSheetName">
                                        <mat-label>
                                            {{ 'ImportSheetName' | translate: {Default: "Sheet Name"} }}
                                        </mat-label>
        
                                        <input matInput type="text" formControlName="sheetName">
                                    </mat-form-field>
        
                                    <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportStartingRow">
                                        <mat-label>
                                            {{ 'ImportStartingRow' | translate: {Default: "Starting Row"} }}
                                        </mat-label>
        
                                        <input matInput type="number" formControlName="startingRow">
                                    </mat-form-field>
                                </form>
                            </div>
        
                            <app-import-spreadsheet
                                [importId]="importId"
                                [importFile]="currentFile"
                            ></app-import-spreadsheet>
                        </div>
                    </ng-template>
                    
                    <div class="step-actions">
                        <button disabled mat-stroked-button appLocalizationPopupDirective localizationCode="Stepper-Back" matStepperPrevious>
                            {{ 'Stepper-Back' | translate: {Default: 'Back'} }}
                        </button>
                        <button mat-stroked-button appLocalizationPopupDirective localizationCode="Stepper-Next" matStepperNext>
                            {{ 'Stepper-Next' | translate: {Default: 'Next'} }}
                        </button>
                    </div>
                </mat-step>

                <mat-step>
                    <ng-template matStepLabel appLocalizationPopupDirective [localizationCode]="'Import-Step2'">
                        {{ 'Import-Step2' | translate: {Default: 'Column Mapping'} }}
                    </ng-template>

                    <ng-template matStepContent>
                        <div class="step-content step-2">
                            <div class="form-container">
                                <form [formGroup]="importForm" class="import-form">
                                    <mat-form-field appearance="fill" appLocalizationPopupDirective localizationCode="ImportTable">
                                        <mat-label>
                                            {{ 'ImportTable' | translate: {Default: "Table"} }}
                                        </mat-label>
        
                                        <mat-select disableOptionCentering formControlName="table" class="mat-form-field">
                                            <mat-option></mat-option>
        
                                            <mat-option *ngFor="let table of tables" [value]="table.id">
                                                {{table.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
        
                                    <div class="form-section">
                                        <div class="form-section-title">
                                            <h6 appLocalizationPopupDirective localizationCode="ImportColumnMapping">
                                                {{ 'ImportColumnMapping' | translate: {Default: "Column Mapping"} }}
                                            </h6>
                                        </div>
                                        <div class="form-section-contents">
                                            <div class="section-row">
                                                <mat-list>
                                                    <ng-container *ngFor="let columnMapping of getColumnMappingsControls(); let i = index">
                                                        <mat-list-item class="field-list-item">
                                                            <span *ngIf="columnMapping.get('tableField').value">{{columnMapping.get('sheetColumn').value}} - {{getTableFieldName(columnMapping.get('tableField').value)}}</span>
                                                            <span *ngIf="columnMapping.get('type').value">{{columnMapping.get('sheetColumn').value}} - {{getColumnMappingTypeName(columnMapping.get('type').value)}}</span>
        
                                                            <button mat-icon-button [matMenuTriggerFor]="menu" class="actions-btn">
                                                                    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                                                            </button>
                                                            <mat-menu #menu="matMenu">
                                                                <button mat-menu-item appPreventDoubleClick (throttledClick)="openColumnMappingDialog(columnMapping)">
                                                                    <mat-icon class="material-icons-outlined">edit</mat-icon> 
                                                                    <span>{{ 'Edit' | translate: {Default: 'Edit'} }}</span>
                                                                </button>
                                                                <button mat-menu-item appPreventDoubleClick (throttledClick)="openConfirmDeleteMappingDialog(i)">
                                                                    <mat-icon class="material-icons-outlined">close</mat-icon> 
                                                                    <span>{{ 'Delete' | translate: {Default: 'Delete'} }}</span>
                                                                </button>
                                                            </mat-menu>
                                                        </mat-list-item>
        
                                                        <mat-divider></mat-divider>
                                                    </ng-container>
                                                </mat-list>
        
                                                <button mat-stroked-button class="add-localization-btn" setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="openColumnMappingDialog()" appLocalizationPopupDirective localizationCode="AddColumnMapping">
                                                    <mat-icon class="material-icons-outlined">add</mat-icon>
                                                    {{ 'AddColumnMapping' | translate: {Default: "Add Column Mapping"} }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
    
                            <app-import-spreadsheet
                                [importId]="importId"
                                [importFile]="currentFile"
                            ></app-import-spreadsheet>
                        </div>
                    </ng-template>


                    <div class="step-actions">
                        <button mat-stroked-button appLocalizationPopupDirective localizationCode="Stepper-Back" matStepperPrevious>
                            {{ 'Stepper-Back' | translate: {Default: 'Back'} }}
                        </button>
                        <button mat-stroked-button appLocalizationPopupDirective localizationCode="Stepper-Next" matStepperNext>
                            {{ 'Stepper-Next' | translate: {Default: 'Next'} }}
                        </button>
                    </div>
                </mat-step>

                <mat-step *ngIf="importId">
                    <ng-template matStepLabel appLocalizationPopupDirective [localizationCode]="'Import-Step3'">
                        {{ 'Import-Step3' | translate: {Default: 'Validate Import'} }}
                    </ng-template>

                    <ng-template matStepContent>
                        <div class="step-content step-3">
                            <div class="top">
                                <app-bootstrap-alert 
                                    localizationCode="ValidateImportTooltip" 
                                    type="info"
                                    [button]="{
                                        localizationCode: 'ValidateImportFile'
                                    }"
                                    (buttonClick)="validateImportFile()"
                                >
                                </app-bootstrap-alert>
                            </div>
                            <div class="bottom">
                                <app-import-spreadsheet
                                    [importId]="importId"
                                    [importFile]="currentFile"
                                ></app-import-spreadsheet>
        
                                <app-import-log-data-grid 
                                    *ngIf="importId" 
                                    [importId]="importId"
                                ></app-import-log-data-grid>
                            </div>
                        </div>
                    </ng-template>


                    <div class="step-actions">
                        <button mat-stroked-button appLocalizationPopupDirective localizationCode="Stepper-Back" matStepperPrevious>
                            {{ 'Stepper-Back' | translate: {Default: 'Back'} }}
                        </button>
                        <button mat-stroked-button appLocalizationPopupDirective localizationCode="Stepper-Next" matStepperNext>
                            {{ 'Stepper-Next' | translate: {Default: 'Next'} }}
                        </button>
                    </div>
                </mat-step>

                <mat-step *ngIf="importId">
                    <ng-template matStepLabel appLocalizationPopupDirective [localizationCode]="'Import-Step4'">
                        {{ 'Import-Step4' | translate: {Default: 'Finalize Import'} }}
                    </ng-template>

                    <ng-template matStepContent>
                        <div class="step-content step-4">
                            <div class="top">
                                <app-bootstrap-alert 
                                    *ngIf="showImportButtons" 
                                    localizationCode="TriggerImportTooltip" 
                                    type="info"
                                    [button]="{
                                        localizationCode: 'TriggerImport'
                                    }"
                                    (buttonClick)="openConfirmImportDialog()"
                                >
                                </app-bootstrap-alert>
                            </div>
                            <div class="bottom">
                                <app-import-spreadsheet
                                    [importId]="importId"
                                    [importFile]="currentFile"
                                ></app-import-spreadsheet>
        
                                <app-import-log-data-grid 
                                    *ngIf="importId" 
                                    [importId]="importId"
                                ></app-import-log-data-grid>
                            </div>  
                        </div>
                    </ng-template>


                    <div class="step-actions">
                        <button mat-stroked-button appLocalizationPopupDirective localizationCode="Stepper-Back" matStepperPrevious>
                            {{ 'Stepper-Back' | translate: {Default: 'Back'} }}
                        </button>
                    </div>
                </mat-step>
            </mat-stepper>
        </mat-card-content>
    </mat-card>
</app-layout>